module.exports = __webpack_public_path__ + "static/media/rexoz shot 1.dc88cfa6.webp";